import type { TOC } from '@ember/component/template-only';

export interface TioQuicklinkButtonSignature {
  Args: {
    buttonText: string;
    isDisabled?: boolean;
    method: () => void;
  };
  Element: HTMLButtonElement;
}

const TioQuicklinkButton: TOC<TioQuicklinkButtonSignature> = <template>
  <button
    type="button"
    {{on "click" @method}}
    disabled={{@isDisabled}}
    class="text-lg tio-bg-surface h-10 tio-fg-secondary disabled:tio-fg-disabled align-right p-2 w-full
      {{unless @isDisabled 'hover:tio-bg-sunken hover:cursor-pointer'}}
      "
  >
    {{@buttonText}}
  </button>
</template>;

export default TioQuicklinkButton;
